var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'v-loading',
    _vm.small && 'v-loading--small',
    _vm.medium && 'v-loading--medium'
  ],attrs:{"role":"status","aria-label":_vm.$t('Indlæser', 'components.loading.label')}},[_vm._m(0),(_vm.$slots.default)?_c('v-text',{staticClass:"v-loading__content"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-loading__spinner"},[_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }